import { Reversible, TopBar } from '@capsicum/common-web';
import { ChevronLeftIcon } from '@capsicum/common-web/icons';
import styled, { useTheme } from 'styled-components';

export type NavigationMenuProps = {
	onClickBackButton: () => void;
	title?: string;
};

export const HEADER_HEIGHT = 64;

export const NavigationMenu = ({ onClickBackButton, title }: NavigationMenuProps) => {
	const { colors } = useTheme() || {};

	const headerLeftIcons = () => {
		return [
			<Reversible key="profile">
				<S.ArrowBack
					color={colors.text.main.enabled}
					data-testid="home-top-bar-back"
					height={30}
					width={30}
					onClick={onClickBackButton}
				/>
			</Reversible>
		];
	};

	return (
		<TopBar
			backgroundColor={colors.backgrounds.main.container}
			borderColor="transparent"
			headerLeft={headerLeftIcons()}
			testID="navigation-top-bar"
			textColor="enabled"
			title={title || ''}
			variant="subpage"
		/>
	);
};

export namespace S {
	export const ArrowBack = styled(ChevronLeftIcon)`
		cursor: pointer;
	`;
}
